export function hasRole(roles: string[] | undefined, role: string): boolean {
  return roles?.includes(role) ?? false;
}

export function isSuperAdmin(roles: string[] | undefined): boolean {
  return hasRole(roles, "super_admin");
}

export function isOrgAdmin(roles: string[] | undefined): boolean {
  return hasRole(roles, "org_admin") || hasRole(roles, "super_admin");
}

export function isStaff(roles: string[] | undefined): boolean {
  return (
    hasRole(roles, "staff") ||
    hasRole(roles, "org_admin") ||
    hasRole(roles, "super_admin")
  );
}
